// extracted by mini-css-extract-plugin
export default {"root":"SpeedTestCard_root__ZaEjM"};